function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M46.3 35.598a1.67 1.67 0 001.68-1.66c0-.905-.743-1.66-1.68-1.66a1.67 1.67 0 00-1.679 1.66c0 .923.762 1.66 1.68 1.66z",
  fill: "#384B51"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M59.738 18C42.72 18 29 32.699 29 48.879c0 15.974 28.212 51.957 29.413 53.481.319.404.808.64 1.325.64.518 0 1.007-.236 1.326-.64 1.2-1.524 29.413-37.507 29.413-53.481C90.477 32.719 76.775 18 59.738 18zm27.38 30.879c0 12.353-19.846 39.856-27.38 49.724-7.59-9.94-27.379-37.402-27.379-49.724 0-14.68 12.794-27.559 27.38-27.559 14.584 0 27.378 12.878 27.378 27.559z",
  fill: "#384B51"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M59.738 27.297c-2.866 0-5.514.519-8.332 1.633a1.654 1.654 0 00-.935 2.158 1.687 1.687 0 002.183.924c2.44-.964 4.626-1.395 7.084-1.395 10.188 0 18.477 8.193 18.477 18.262 0 10.07-8.289 18.262-18.477 18.262-10.187 0-18.476-8.193-18.476-18.262 0-3.125.792-6.126 2.356-8.92a1.65 1.65 0 00-.656-2.256 1.691 1.691 0 00-2.284.649c-1.841 3.292-2.776 6.834-2.776 10.527 0 11.9 9.796 21.582 21.836 21.582s21.836-9.681 21.836-21.582c0-11.9-9.795-21.582-21.836-21.582z",
  fill: "#384B51"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M50.19 58.755l9.548-3.146 9.547 3.146c.64.21 1.353.023 1.8-.488.445-.507.538-1.23.234-1.83L61.24 36.515l-.009-.014c-.618-1.19-2.357-1.214-2.988 0l-.008.014-10.078 19.922c-.304.6-.212 1.323.233 1.83.446.508 1.156.7 1.8.488zm11.228-6.092V44.29L66.5 54.337l-5.082-1.674zm-3.36-8.373v8.373l-5.082 1.674L58.06 44.29z",
  fill: "#E6283D"
});

function SvgGpsLocationPinRed(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgGpsLocationPinRed;